<template>
  <div>
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
    </div>

    <!-- Content Row -->
    <div class="row">
      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-primary shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-primary text-uppercase mb-1"
                >Anzahl Mitglieder (Aktuell)</div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">{{memberCount}}</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-calendar fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-success shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-success text-uppercase mb-1"
                >Freie Plätze</div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">xxx</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Earnings (Monthly) Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-info shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="text-xs font-weight-bold text-info text-uppercase mb-1">Buchungsstand</div>
                <div class="row no-gutters align-items-center">
                  <div class="col-auto">
                    <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800">50%</div>
                  </div>
                  <div class="col">
                    <div class="progress progress-sm mr-2">
                      <div
                        class="progress-bar bg-info"
                        role="progressbar"
                        style="width: 50%"
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-clipboard-list fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Pending Requests Card Example -->
      <div class="col-xl-3 col-md-6 mb-4">
        <div class="card border-left-warning shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div
                  class="text-xs font-weight-bold text-warning text-uppercase mb-1"
                >Offene Anfragen</div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">xxx</div>
              </div>
              <div class="col-auto">
                <i class="fas fa-comments fa-2x text-gray-300"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Row -->

    <div class="row">
      <!-- Area Chart -->
      <div class="col-xl-8 col-lg-7">
        <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
            <h6 class="m-0 font-weight-bold text-primary">Willkommen</h6>
          </div>
          <!-- Card Body -->
          <div class="card-body">
            <p>Herzlich Willkommen im Verwaltungstool der SSU</p>
            <a
              class="btn btn-primary"
              href="https://app.preview.skischule-unterland.de/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Vorschau-Version öffnen
            </a>
          </div>
        </div>
      </div>

      <!-- Pie Chart -->
      <div class="col-xl-4 col-lg-5">
        <div class="card shadow mb-4">
          <!-- Card Header - Dropdown -->
          <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
            <h6 class="m-0 font-weight-bold text-primary">Links</h6>
          </div>
          <!-- Card Body -->
          <div class="card-body">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
</style>


<script>

import { mapState, mapActions } from "vuex";
import { MEMBERS_NAMESPACE } from "@/store/namespace-types";
import { GET_MEMBERCOUNT } from "../store/action-types";

export default {
  name: "SSUDashboard",
  methods: {
    ...mapActions(MEMBERS_NAMESPACE, {
      getMemberCount: GET_MEMBERCOUNT // map `this.add()` to `this.$store.dispatch('increment')`
    }),
    async loadStatistic() {
      this.getMemberCount()
    },
  },
  computed: {
    ...mapState(MEMBERS_NAMESPACE, {
      memberCount: state => state.count
    }),
  },
  mounted() {
    this.loadStatistic();
  },
};
</script>